import { noop } from 'rxjs'
import { PromptType, BoolPrompt } from 'jobs/prompts/prompt-types'
import { IPromptInputEditorViewModel } from '../IPromptInputEditorViewModel'

/**
 * View Model for a Yes/No Prompt Input type.
 */
export class BoolPromptInputEditorViewModel
  implements IPromptInputEditorViewModel
{
  /**
   * Maps this View Model to a Yes/No Prompt Input Type.
   */
  toInput(): BoolPrompt {
    return {
      type: PromptType.Bool,
    }
  }

  /**
   * @inheritdoc
   */
  validate() {
    return true
  }

  /**
   * @inheritdoc
   */
  reset = noop
}
